import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ChildDetail } from '../../../../../model/km-jour.model';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RealtimeService } from 'src/app/client-management/realtime/services/realtime.service';
import { ToolKmJourService } from 'src/app/client-management/realtime/services/tool-km-jour.service';
import { ChartParametre } from 'src/app/client-management/realtime/model/chart-parameter.model';
import { DataManagementService } from 'src/app/client-management/data-management';

@Component({
  selector: 'km-jour-trajet-item',
  templateUrl: './km-jour-trajet-item.component.html',
  styleUrls: ['./km-jour-trajet-item.component.css'],
})
export class KmJrTrajetItemComponent {
  @Input() childDetail: ChildDetail;
  @Input() useFms: boolean;
  @Output('displayDash') displayDash = new EventEmitter<ChartParametre>();

  isMultiSelectTrajet = false;
  isMultiSelectTrajet$ : Subscription;
  selectedTrajets: ChildDetail[] = [];

  
  constructor(
    private toolKmJourService: ToolKmJourService,
    public dataManagementService: DataManagementService,
    private router: Router,
    private route: ActivatedRoute,
    private realTimeService: RealtimeService
  ) {}

  ngOnInit() {
   this.isMultiSelectTrajet$ = this.toolKmJourService.getIsMultiSelectTrajet().subscribe((isMultiSelect) => {
      this.isMultiSelectTrajet = isMultiSelect;
    });
  }

  goToSimulation() {
     if (this.isMultiSelectTrajet) {
      this.toolKmJourService.toggleMultiSelectTrajet(this.childDetail);
      return;
    }
    this.toolKmJourService.setChildPath(this.childDetail);
    this.toolKmJourService.setDestination('../');
    this.realTimeService.setBarToolStatus(false);
    this.router.navigate(['trajet'], {relativeTo: this.route});
    this.displayDash.emit({
      intervald: {startDate: this.childDetail.beginPathTime, 
        endDate:this.childDetail.endPathTime}, 
        time: 5,
        height: 150, 
        fontSize: "10px"
    })
  }


  isSelected(child: ChildDetail): boolean {
    return this.toolKmJourService.isTrajetSelected(child.beginPathTime);
  }

  ngOnDestroy() {
    if (this.isMultiSelectTrajet$) {this.isMultiSelectTrajet$.unsubscribe();}
  }


    
  calculeConsumation(consumtion: any): string {
    if (!consumtion || consumtion > 100) {
        return "0";
    } else {
        return consumtion.toFixed(2) + " %";  // Convert the number to a string with 2 decimal places
    }
  }

}
